module.exports = __webpack_public_path__ + "img/29_newYouth_zj.b573ea51.png";